import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, Fonts } from "../../coldcompute";

/** YouTube thumbnail (1280×720). One focal subject + bold 3–4 words, high contrast. */
export const LastTenPercentIsTrustThumb: React.FC = () => (
  <AbsoluteFill
    style={{
      background: `radial-gradient(95% 95% at 76% 16%, #0e1626 0%, ${COLORS.bg} 56%, ${COLORS.bg2} 100%)`,
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: "column",
      padding: "0 84px",
    }}
  >
    <Fonts />
    {/* faint scanline grain */}
    <AbsoluteFill
      style={{
        opacity: 0.06,
        mixBlendMode: "screen",
        backgroundImage: "repeating-linear-gradient(0deg, #fff 0 1px, transparent 1px 3px)",
      }}
    />
    {/* giant focal 10% */}
    <div
      style={{
        position: "absolute",
        right: 30,
        top: -70,
        fontFamily: FONTS.display,
        fontWeight: 700,
        fontSize: 560,
        lineHeight: 1,
        color: COLORS.amber,
        opacity: 0.2,
        letterSpacing: "-0.04em",
      }}
    >
      10%
    </div>
    {/* the 90/10 progress bar motif */}
    <div
      style={{
        position: "absolute",
        right: 84,
        bottom: 70,
        width: 520,
        height: 22,
        border: `1px solid ${COLORS.line}`,
        borderRadius: 6,
        overflow: "hidden",
        display: "flex",
      }}
    >
      <div style={{ width: "90%", background: COLORS.line }} />
      <div style={{ width: "10%", background: COLORS.amber, boxShadow: `0 0 22px -2px ${COLORS.amber}` }} />
    </div>

    <div
      style={{
        fontFamily: FONTS.mono,
        fontSize: 30,
        letterSpacing: "0.22em",
        textTransform: "uppercase",
        color: COLORS.cyan,
        marginBottom: 18,
      }}
    >
      ▍solo · enterprise rag
    </div>
    <div
      style={{
        fontFamily: FONTS.display,
        fontWeight: 700,
        fontSize: 138,
        lineHeight: 0.92,
        letterSpacing: "-0.02em",
        color: COLORS.text,
      }}
    >
      THE LAST <span style={{ color: COLORS.amber }}>10%</span>
      <br />
      IS <span style={{ color: COLORS.cyan }}>TRUST</span>
    </div>
    <div
      style={{
        fontFamily: FONTS.mono,
        fontSize: 26,
        color: COLORS.dim,
        marginTop: 26,
      }}
    >
      grounding · gates · honest shipping — not features
    </div>
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
